module.exports = __webpack_public_path__ + "img/logo_footer.9496d7c7.svg";